import React from "react";
import { boundError } from "../../utils";

const CutOffLineRaw = ({ style }) => {
  return <div style={{ ...style, borderBottom: "0.5px solid #d4d4d4" }}></div>;
};

export const CutOffLine = boundError(CutOffLineRaw);
